import React from "react";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import LoginButton from "../LoginButton";
import Profil from "../Profil";
import { appBarStyles, appBarUserRoleLabels } from "./appBarTheme";

const styles = (theme: Theme) => createStyles(appBarStyles(theme));

interface Props {
  classes: {
    userSlot: string;
    userActionButton: string;
    profileButton: string;
    profileIcon: string;
    profileTextBlock: string;
    profileName: string;
    profileRole: string;
  };
  user: any;
  onLogout: () => void;
  showRole?: boolean;
}

const AppBarUserSlot = ({
  classes,
  user,
  onLogout,
  showRole = false,
}: Props) => {
  const roleLabel =
    user?.authorities?.[0] != null
      ? (
          appBarUserRoleLabels[user.authorities[0]] ?? user.authorities[0]
        ).toLowerCase()
      : undefined;

  return (
    <div className={classes.userSlot}>
      {user ? (
        <Profil
          onLogout={onLogout}
          buttonClassName={classes.profileButton}
          iconClassName={classes.profileIcon}
          textBlockClassName={classes.profileTextBlock}
          nameClassName={classes.profileName}
          showRole={showRole}
          roleLabel={roleLabel}
          roleClassName={classes.profileRole}
        />
      ) : (
        <LoginButton
          onLogout={onLogout}
          className={classes.userActionButton}
        />
      )}
    </div>
  );
};

export default withStyles(styles)(AppBarUserSlot);
